import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 1,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 border-b ${scrolled ? 'bg-navy/95 backdrop-blur-md border-steel' : 'bg-transparent border-transparent'}`} data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 flex items-center justify-between" data-id="element-93">
        <button onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="flex items-center space-x-3 group" data-id="element-94">
          <Compass className="w-7 h-7 text-gold transition-transform duration-700 group-hover:rotate-45" strokeWidth={1.5} data-id="element-95" />
          <span className="font-display text-xl tracking-tight text-cream" data-id="element-96">
            BPF LLC
          </span>
        </button>

        <div className="hidden md:flex items-center space-x-8 text-[11px] font-semibold tracking-[0.2em] uppercase text-muted" data-id="element-97">
          <button onClick={() => scrollTo('identidad')} className="hover:text-cream transition-colors duration-300" data-id="element-98">
            Identidad
          </button>
          <button onClick={() => scrollTo('filosofia')} className="hover:text-cream transition-colors duration-300" data-id="element-99">
            Filosofía
          </button>
          <button onClick={() => scrollTo('actividades')} className="hover:text-cream transition-colors duration-300" data-id="element-100">
            Actividades
          </button>
          <button onClick={() => scrollTo('jurisdiccion')} className="hover:text-cream transition-colors duration-300" data-id="element-101">
            Jurisdicción
          </button>
          <button onClick={() => scrollTo('contacto')} className="hover:text-cream transition-colors duration-300" data-id="element-102">
            Contacto
          </button>
        </div>
      </div>
    </motion.nav>;
}